<template>
  <NavBar />
  <header class="lg:px-16 px-5 bg-white flex flex-wrap items-center py-3">
    <div class="flex-1 flex justify-between items-center">
      <div class="relative">
        <a href="javascript.void(0)" class="block text-3xl font-redHat text-[#F5CA40] font-bold">
          Rekap Perlu di Beli
        </a>
        <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Verifikasi Data</p> -->
      </div>
      <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Story Instagram</p> -->
    </div>

    <div class="hidden md:flex md:items-center md:w-auto w-full" id="menu">
      <nav>
        <ul class="md:flex items-top justify-between text-base text-gray-700 pt-3 md:pt-0 gap-1">
          <li class="" v-if="this.records.length > 0">
            <div
              class="font-redHat text-base  h-[40px] w-[150px] rounded-md text-white  border-2 bg-black me-2 cursor-pointer"
              @click='print_label'>
              <div class="flex justify-center items-center h-full gap-2">
                <i class="bi bi-printer me-2"></i>
                Print label
              </div>
            </div>
          </li>
          <li class="" v-if="this.records.length == 0 && status_generate && buyStatufFilter == ''">
            <div @click="isModalOpen = true"
              class="font-redHat text-base  h-[40px] w-[243px] rounded-md text-white  border-2 bg-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/refresh.png" alt="">
                Generate
              </div>
            </div>
          </li>
          <li v-if="this.records && this.records.length > 0">
            <div @click="convertToExcel"
              class="font-redHat text-base  h-[40px] w-[150px] rounded-md text-green-600  border-2 border-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/icon_excel.png" alt="">
                Export Excel
              </div>
            </div>
          </li>
          <li>
            <div
              class="relative flex items-center p-0 rounded-[8px] w-[250px] max-w-lg h-[40px] border-[0.5px] border-[#5FBAE6]">
              <input type="text" v-model="searchQuery" @input="filterTable"
                class="rounded-[8px] p-2.5 px-6 w-full h-full focus:border-blue-500  border-[#5FBAE6] " name="search"
                placeholder="Cari">
              <button type="submit"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 z-1 bg-white  p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </button>
            </div>
          </li>
          <li>
            <div class="mb-2">
              <input type="date" v-model="date" class="flex-grow border-1 border-[#5FBAE6] rounded-md p-2"
                name="date_choose">
            </div>
            <div>
              <select id="countries"
                class="bg-white border border-[#5FBAE6] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                v-model="buyStatufFilter">
                <option value="" selected>Semua</option>
                <option value="PENDING">PENDING</option>
                <option value="KEEP">KEEP</option>
                <option value="SOLDOUT">SOLD OUT</option>
              </select>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </header>



  <div class="px-5 pt-5 mb-2">
    <div class="overflow-scroll" style="max-height:60vh;">
      <table id="example" class="display" style="width: 100%;">
        <thead style="position: sticky; top: 0; background-color: white; z-index: 1;">
          <tr v-if="filteredRecords.length > 0">
            <th style="width: 5%">No.</th>

            <th style="width: 10%" @click="sortColumn('supplier_name')" class="cursor-pointer">
              Supplier
              <i v-if="sortKey === 'supplier_name' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'supplier_name' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 10%" @click="sortColumn('category')" class="cursor-pointer">
              Kategori
              <i v-if="sortKey === 'category' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'category' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 15%" @click="sortColumn('code')" class="cursor-pointer">
              Produk
              <i v-if="sortKey === 'code' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'code' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>


            <th style="width: 5%" @click="sortColumn('color')" class="cursor-pointer">
              Varian
              <i v-if="sortKey === 'color' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'color' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 5%" @click="sortColumn('size')" class="cursor-pointer">
              size
              <i v-if="sortKey === 'size' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'size' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 5%" @click="sortColumn('qty')" class="cursor-pointer">
              Qty
              <i v-if="sortKey === 'qty' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'qty' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>
            <th style="width: 5%" @click="sortColumn('qty_pending')" class="cursor-pointer">
              Qty Pending
              <i v-if="sortKey === 'qty_pending' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'qty_pending' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>
            <th style="width: 5%" @click="sortColumn('qty_buy')" class="cursor-pointer">
              Qty di Terima
              <i v-if="sortKey === 'qty_buy' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'qty_buy' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 10%" @click="sortColumn('cost_price')" class="cursor-pointer">
              Harga Modal
              <i v-if="sortKey === 'cost_price' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'cost_price' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>

            <th style="width: 10%" @click="sortColumn('total')" class="text-center cursor-pointer">
              Total
              <i v-if="sortKey === 'total' && sortDirection === 'asc'" class="bi bi-arrow-up"></i>
              <i v-if="sortKey === 'total' && sortDirection === 'desc'" class="bi bi-arrow-down"></i>
            </th>
            <th style="width: 20%" class="text-center">
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr-table" v-for="(item, index) in filteredRecords" :key="item.id">
            <td class="custom-td-left">{{ index + 1 }}</td>
            <td class="">
              <div class="m-2">{{ item.supplier_name }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.category }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.code }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.color }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.size }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.qty }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.qty_pending }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ item.qty_buy }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ currencyInput(item.cost_price, currency) }}</div>
            </td>
            <td class="">
              <div class="m-2">{{ currencyInput(item.total, currency) }}</div>
            </td>
            <td class="">
              <div class="d-flex justify-center m-2">

                <button type="button" @click='editData(item)'
                  class="font-redHat text-base  h-[40px] px-3 rounded-md text-white  border-2  me-2 cursor-pointer"
                  :class="{
                    'bg-green-600': (item.buy_status == 'BOOK' || ((item.buy_status == 'PENDING' || item.buy_status == 'KEEP') && (item.qty_pending > 0 || item.qty_buy == 0))) && currentDate == item.date,
                    'bg-red-600': item.buy_status == 'SOLDOUT',
                    'bg-gray-600': item.buy_status != 'BOOK' || currentDate != item.date
                  }"
                  :disabled="(item.buy_status != 'BOOK' && item.buy_status != 'PENDING' && item.buy_status != 'KEEP') || currentDate != item.date">
                  <span v-if="(item.buy_status == 'BOOK' || item.buy_status == 'OK') && item.qty_pending == 0">
                    Terima Barang
                  </span>
                  <span v-else-if="item.buy_status == 'PENDING'">
                    PENDING
                  </span>
                  <span v-else-if="item.buy_status == 'KEEP'">
                    KEEP
                  </span>
                  <span v-else>
                    SOLD OUT
                  </span>
                </button>
              </div>
            </td>
          </tr>
          <tr class="tr-table" v-if="filteredRecords.length > 0">
            <td colspan="6" class="custom-td-left fw-bold">Total</td>
            <td class="custom-td-left fw-bold text-start">{{ totalQty }}</td>
            <td></td> <!-- untuk pemisah antara qty sama total -->
            <td></td> <!-- untuk pemisah antara qty sama total -->
            <td></td> <!-- untuk pemisah antara qty sama total -->
            <td class="custom-td-right fw-bold text-center">{{ currencyInput(total, currency) }}</td>
            <td class=""></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- modal delete -->
  <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <!-- Modal content -->
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" @click.stop>
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Generate </h2>
        <button @click="closeModal" class="text-red-600 hover:text-gray-900">
          ✕
        </button>
      </div>
      <p class="text-gray-700 mb-10">
        generate hanya bisa dilakukan sekali di hari ini dan baru bisa dilakukan generate kembali esok hari.
        Apakah anda yakin ingin mengenerate laporan ini ?
      </p>
      <div class="space-y-3">
        <div aria-hidden="true" class="border-t px-2"></div>
        <div class="button-group flex justify-end">
          <button @click="closeModal" class="bg-gray-400 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 me-3">
            Batal
          </button>
          <button @click="generate" class="bg-green-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700">
            Generate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import axios from "axios";
// import Swal from 'sweetalert2';

import { ErrorConnectionTimeOut, ShowLoading, CloseLoading, base_url, AlertPopup, AlertBottom, rupiahInput, rupiah, goPage, DateFormat, currencyInput, generateExcel } from "@/assets/js/function";
// import {ErrorConnectionTimeOut,  ShowLoading, CloseLoading, base_url, AlertPopup,  rupiahInput,  rupiah } from "@/assets/js/function";
import Cookies from "js-cookie";
import Multiselect from 'vue-multiselect';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueDatepickerUi from 'vue-datepicker-ui';
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  components: {
    NavBar,
    Multiselect,
    Datepicker: VueDatepickerUi
  },

  data() {
    return {
      searchQuery: '',

      records: [
        {
          total_deposit: '',
        }
      ],
      currentData: [],
      listStatusPesanan: [],
      isModalOpen: false,
      currentDeleteIndex: null,
      config: '',
      filterDropdown: false,
      selectedType: 'LIVE_IG',
      total: 0,

      date: new Date(),
      currentDate: "",

      dateRange: [
        new Date(),
        new Date()],
      currency: "",

      sortKey: '',         // Column key to sort by
      sortDirection: 'asc', // Sort direc

      status_generate: true,
      buyStatufFilter: "",

    }
  },

  watch: {
    date: {
      handler(newVal) {
        localStorage.setItem('report_date', newVal)
        this.index();

        // Convert both dates into Date objects for proper comparison
        const dateToCompare = new Date();
        dateToCompare.setHours(0, 0, 0, 0); // Set time to 00:00:00.000

        const storedDate = new Date(this.date);
        storedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00.000

        // Compare the time values of the two dates
        if (storedDate.getTime() !== dateToCompare.getTime()) {
          this.status_generate = false;
        } else {
          this.status_generate = true;
        }
      },
    },
    buyStatufFilter: {
      handler(newVal) {
        this.index();
      },
    }
    // dateRange: {
    //   handler(newVal) {
    //     this.index();
    //   },
    // }
  },

  created() {
    const token = Cookies.get("token");
    // console.log(token)
    this.config = {
      headers: { Authorization: `Bearer ` + token },
      timeout: 100000,
    }

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');

    if (localStorage.getItem('report_date') == null) {
      this.date = `${year}-${month}-${day}`;
    } else {
      this.date = localStorage.getItem('report_date');
    }

    //2
    const now2 = new Date();
    const year2 = now2.getFullYear();
    const month2 = String(now2.getMonth() + 1).padStart(2, '0');
    const day2 = String(now2.getDate()).padStart(2, '0');
    this.currentDate = `${year2}-${month2}-${day2}`;

    // console.log(this.config);
    this.index();
    this.prepareData();


    this.showMultiselect = false;

    // Load from localStorage when the component is created
    // const savedLiveIg = localStorage.getItem('records');
    // if (savedLiveIg) {
    // this.records = JSON.parse(savedLiveIg); // Load saved data into records
    // console.log('Stored records:', JSON.parse(savedLiveIg));
    // }else {
    // console.log('No records found in localStorage.');
    // }
  },

  computed: {
    filteredRecords() {
      let records = [...this.records];

      // Filter records based on search query
      if (this.searchQuery) {
        const searchLower = this.searchQuery.toLowerCase();
        records = records.filter(item => {
          return (
            (item.supplier_name ? item.supplier_name.toLowerCase().includes(searchLower) : false) ||
            (item.category ? item.category.toLowerCase().includes(searchLower) : false) ||
            (item.code ? item.code.toLowerCase().includes(searchLower) : false) ||
            (item.name ? item.name.toLowerCase().includes(searchLower) : false) ||
            (item.qty ? String(item.qty).includes(searchLower) : false) ||
            (item.cost_price ? String(item.cost_price).includes(searchLower) : false) ||
            (item.total ? String(item.total).includes(searchLower) : false)
          );
        });
      }

      // Sort records based on the selected column and direction
      if (this.sortKey) {
        records.sort((a, b) => {
          const valueA = a[this.sortKey];
          const valueB = b[this.sortKey];

          if (typeof valueA === 'string') {
            // If the values are strings, compare them alphabetically
            return this.sortDirection === 'asc'
              ? valueA.localeCompare(valueB)
              : valueB.localeCompare(valueA);
          } else {
            // If the values are numbers, compare them numerically
            return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
          }
        });
      }

      return records;
    },

    totalQty() {
      return this.filteredRecords.reduce((sum, item) => sum + (item.qty || 0), 0);
    },
  },


  // mounted() {
  //     this.$root.initializeDataTable(); 

  // },

  methods: {

    rupiah,
    currencyInput,
    addNumberToObjects(objArray) {
      for (let i = 0; i < objArray.length; i++) {
        const { code, supplier_name, category, color, qty, qty_pending, qty_buy, size, cost_price, total, buy_status, ...rest } = objArray[i];  // Extract fields to be renamed
        const newObj = {
          No: i + 1,
          "Supplier": supplier_name,  // Rename id_customer to customer_id
          "Kategori": category,  // Rename id_customer to customer_id
          "Kode Produk": code,  // Rename id_customer to customer_id
          "Varian": color,
          "Size": size,
          "Qty": qty,// - qty_pending
          "Qty pending": qty_pending,
          "Qty diterima": qty_buy,
          "Harga Modal": cost_price,
          "Total": total,
          "Status": buy_status,
          ...rest
        };
        objArray[i] = newObj;
      }
      return objArray;
    },
    convertToExcel() {
      ShowLoading();

      // Create a deep copy of `this.records` to avoid modifying the original data
      // const data = JSON.parse(JSON.stringify(this.records));
      const data = JSON.parse(JSON.stringify(this.filteredRecords));
      const ArrExport = this.addNumberToObjects(data);

      for (let i = 0; i < ArrExport.length; i++) {
        delete ArrExport[i]["id"];
        delete ArrExport[i]["category"];
        delete ArrExport[i]["cost_price"];
        delete ArrExport[i]["supplier_name"];
        delete ArrExport[i]["name"];
        delete ArrExport[i]["id_supplier"];
        delete ArrExport[i]["id_product"];
        delete ArrExport[i]["id_category"];
        delete ArrExport[i]["qty_buy"];
        delete ArrExport[i]["qty_pending"];
        delete ArrExport[i]["buy_status"];
      }

      const footerRow = {
        No: '', // Leave the No column empty for the footer
        Supplier: '', // Empty for footer
        Kategori: '', // Empty for footer
        "Kode Produk": '', // Empty for footer
        Varian: '', // Empty for footer
        Size: 'TOTAL', // Empty for footer
        "Qty": this.totalQty,// Total of qty_buy
        "Qty pending": '', // Empty for footer
        "Qty diterima": '',
        "Harga Modal": '', // Empty for footer
        Total: this.currencyInput(this.total, this.currency), // Total cost formatted as currency
        Status: '' // Empty for footer
      };

      ArrExport.push(footerRow);

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Create a new worksheet
      const ws = XLSX.utils.json_to_sheet(ArrExport);
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'REKAP');
      // Convert the workbook to an XLSX file and download it
      XLSX.writeFile(wb, 'PERLU DI BELI' + ".xlsx");
      CloseLoading();
    },

    sortColumn(column) {
      if (this.sortKey === column) {
        // Toggle sort direction if already sorting by this column
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Set sort key to new column and default direction to ascending
        this.sortKey = column;
        this.sortDirection = 'asc';
      }
    },
    nameWithLang({ name }) {
      return `${name}`;
    },

    addRow() {
      // Mark the row as "Added"
      //   this.record[index].isAdded = true

      // Add a new row with a unique id
      this.records.push({
        id_customer: '',
        id_produk: '',
        color: '',
        size: '',
        qty: '',
        price: '',
        deposit: '',
        isAdded: false
      })
    },
    getIconClass(item) {
      // Determine the icon class based on whether the row is the last one
      // return item.total_deposit > item.price ? 'bi bi-check-circle-fill text-gray-400' : 'bi bi-check-circle-fill text-[#50C996]' ;
      // console.log(item.total_deposit)
      // console.log(item.price)
      if (item.total_deposit >= item.price) {
        //return 'bi bi-check-circle-fill text-[#50C996]'; // Green verified
        return true
      }
      else {
        //return 'bi bi-check-circle-fill text-gray-400'; // Gray unverified
        return false
      }
    },
    formatCurrency(label, number, index) {
      this.records[index][label] = rupiahInput(number);
    },
    prepareData() {
      // this.records.total_deposit = rupiahInput(this.records.total_deposit);
      this.records.forEach((item) => {
        item.total_deposit = rupiahInput(item.total_deposit);
      });

    },
    editData(item) {
      // for batal edit customer page
      localStorage.setItem('currentData', JSON.stringify(item));
      goPage('accept');

    },
    editCustomer(item) {
      // for batal edit customer page
      this.$router.push({ name: 'editcustomer' });
      sessionStorage.setItem('lastPage', 'verifikasi-live-ig');

      // console.log(item)
      localStorage.setItem('currentData', JSON.stringify(item.customer_detail));

      // Navigate to the Add Customer page
      this.$router.push({ name: 'editcustomer' });
    },
    filterRecords(type) {
      this.selectedType = type; // Save the selected filter type
      this.index(); // Call the index method to fetch filtered data
    },
    index() {
      ShowLoading();
      let formData = new FormData();

      formData.append('id_preorder', localStorage.getItem('id_preorder'))
      formData.append('date', this.date);
      formData.append('buy_status', this.buyStatufFilter);
      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'report_summary_buy';
      } else {
        this.api = base_url + 'report_summary_buy';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          console.log(response.data)
          if (response.data.status === true) {
            this.records = response.data.data;
            this.total = response.data.total_result_value;
            this.currency = response.data.currency;
            localStorage.getItem('id_preorder');
            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    },
    generate() {
      ShowLoading();
      let formData = new FormData();
      formData.append('id_preorder', localStorage.getItem('id_preorder'))
      formData.append('date', this.date);

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'generate_buy_summary';
      } else {
        this.api = base_url + 'generate_buy_summary';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status === true) {
            this.records = [];
            this.total = response.data.total_result_value;
            this.currency = response.data.currency;
            this.index();
            this.isModalOpen = false;
            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    },
    openModalDelete() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.id_terminate = null;
    },
    delete2() {
      ShowLoading();
      let formData = new FormData();
      formData.append("id", this.id_terminate);

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'live_ig_delete';
      } else {
        this.api = base_url + 'live_ig_delete';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {

          if (response.data.status == true) {
            const index = this.records.findIndex((item) => item.id === this.id_terminate); // Find item in the array by ID
            this.records.splice(index, 1); // Remove the item from the array
            CloseLoading();
            this.closeModal(); // Close modal after deletion
            AlertBottom(response.data.message);

          } else {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {

          ErrorConnectionTimeOut(error);
        });


    },
    terminate(id) {
      this.id_terminate = id;
      this.openModalDelete();
      // this.tanggal_terminate = new Date();

    },
    print_label() {
      ShowLoading();
      let formData = new FormData();
      formData.append('id_preorder', localStorage.getItem('id_preorder'))
      formData.append('date', this.date);

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'print_label';
      } else {
        this.api = base_url + 'print_label';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status === true) {

            AlertBottom(response.data.message);
            window.open(base_url + response.data.url, '_blank').focus();
            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    }
  }
}
</script>

<style scoped>
/* Adjust positioning and z-index for the multiselect dropdown */
.multiselect__content {
  position: absolute;
  z-index: 9999;
  top: 100%;
}

.multiselect-full-width .multiselect__select {
  width: 100%;
}

.no-arrows {
  -moz-appearance: textfield;
  /* Firefox */
  appearance: none;
  /* Remove default appearance */
}

.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome, Safari, Edge */
  margin: 0;
  /* Remove margin */
}
</style>